// assets/autoplay-first-video.js
document.addEventListener('DOMContentLoaded', () => {

  const playVideo = (vid, dm) => {
    if (!vid) return;
    vid.muted = true;
    vid.playsInline = true;
    vid.autoplay = true;
    vid.loop = true;
    vid.preload = 'auto';
    const tryPlay = () => vid.play().catch(() => {});
    vid.addEventListener('canplaythrough', tryPlay, { once: true });
    setTimeout(tryPlay, 400);

    const poster = dm.querySelector('.deferred-media__poster');
    if (poster) poster.style.display = 'none';
  };

  const initMedia = (dm) => {
    if (!dm) return;
    if (typeof dm.loadContent === 'function') dm.loadContent(false);
    else if (typeof dm.load === 'function') dm.load(false);

    const immediate = dm.querySelector('video');
    if (immediate) return playVideo(immediate, dm);

    const obs = new MutationObserver((mut, obsr) => {
      mut.forEach((m) =>
        m.addedNodes.forEach((n) => {
          if (n.nodeType === 1 && n.tagName === 'VIDEO') {
            playVideo(n, dm);
            obsr.disconnect();
          }
        })
      );
    });
    obs.observe(dm, { childList: true, subtree: true });
  };

  const allDm = document.querySelectorAll(
    '[id^="GalleryViewer"] deferred-media[data-media-id]'
  );
  allDm.forEach(dm => initMedia(dm));

});